import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HelperService, HTTPService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';
import { SubscriptionExpiryModalComponent } from '../subscription-expiry-modal/subscription-expiry-modal.component';
import { companyTrialStatusConstants } from 'app/constants/company.constants';
import { ToastrService } from 'ngx-toastr';
import { OverlayVideoComponent } from './../../shared/components/overlay-video/overlay-video.component';

@Component({
  selector: 'app-onboarding-checklist',
  templateUrl: './onboarding-checklist.component.html',
  styleUrls: ['./onboarding-checklist.component.scss'],
})
export class OnboardingChecklistComponent implements OnInit {
  @Output() setUpApt = new EventEmitter<any>();
  @Output() setUpRo = new EventEmitter<any>();
  @Output() setUpInvite = new EventEmitter<any>();

  remainingTrialDays: number = 0;
  remainingDayPercentage: string = '0%';
  isLogoUploaded: boolean = false;
  isAppointmentCreated: boolean = false;
  isROCreated: boolean = false;
  isUserCreated: boolean = false;
  isPartsTechUsed: boolean = false;
  trialStatus: string = companyTrialStatusConstants.IN_PROGRESS;
  isSubscriptionRequested: boolean = false;
  isSubscriptionExpired: boolean = false;
  isSupportUser: boolean = false;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    const { isSupportUser } = this.helperService.getCompany();
    this.isSupportUser = isSupportUser;

    this.getCompanyData();
  }

  getCompanyData(): void {
    this.httpService
      .getCompanyDetails(this.helperService.getCompany().companyId)
      .then((data: any) => {
        if (data.trial && data.trial.startDate && data.trial.endDate) {
          this.isSubscriptionRequested =
            data.trial && data.trial.isSubscriptionRequested;
          this.isSubscriptionExpired =
            new Date(data.trial.endDate).getTime() < new Date().getTime();
          this.remainingTrialDays = this.calculateRemainingDays(
            data.trial.endDate
          );
          this.remainingDayPercentage = this.calculateRemainingDayPercentage(
            data.trial.startDate,
            data.trial.endDate
          );
        }
        this.isLogoUploaded = data.trial.isLogoUploaded;
        this.isAppointmentCreated = data.trial.isAppointmentCreated;
        this.isROCreated = data.trial.isROCreated;
        this.isUserCreated = data.trial.isUserCreated;
        this.isPartsTechUsed = data.trial.isPartsTechUsed;

        // if trial expired show non closing dialog
        if (this.isSubscriptionExpired && !this.isSupportUser)
          this.expiry(false);
      })
      .catch((err) => this.helperService.showToaster('error', err));
  }

  /**
   * Calculate remaining trial days for trial
   * @param endDate
   * @returns
   */
  calculateRemainingDays(endDate) {
    let diffRemainingTime =
      new Date(endDate).getTime() -
      new Date().setDate(new Date().getDate() - 1);
    if (diffRemainingTime < 0) diffRemainingTime = 0;
    const remainingTrialDays = Math.floor(
      diffRemainingTime / (1000 * 60 * 60 * 24)
    );
    return remainingTrialDays;
  }

  /**
   * Calculate percentage of total remaining days
   * @param startDate
   * @param endDate
   * @returns
   */
  calculateRemainingDayPercentage(startDate, endDate) {
    const diffTotalTime = Math.abs(
      new Date(endDate).getTime() - new Date(startDate).getTime()
    );
    const totalDays = Math.ceil(diffTotalTime / (1000 * 60 * 60 * 24));
    const remainingTrialDays = this.calculateRemainingDays(endDate);
    const remainingDayPercentage = `${(remainingTrialDays / totalDays) * 100}%`;
    return remainingDayPercentage;
  }

  expiry(isClosable: boolean) {
    const ref = this.dialogService.open(SubscriptionExpiryModalComponent, {
      width: '340px',
      styleClass: 'add-dialog expiry-modal',
      showHeader: false,
      closable: isClosable,
      closeOnEscape: isClosable,
      data: { isSubscriptionExpired: this.isSubscriptionExpired },
    });
    const onClose = ref.onClose.subscribe(
      ({ isSuccess, isSubscriptionRequested }) => {
        onClose.unsubscribe();
        if (isSuccess) {
          this.isSubscriptionRequested = !!isSubscriptionRequested;
        }
      }
    );
  }

  openVideoPreview(type: any) {
    let attachment = { url: '' };

    if (type === 'appt') {
      attachment.url =
        'https://autoleapstaticassets.s3.amazonaws.com/Build+an+estimate.mp4';
    } else if (type === 'ro') {
      attachment.url =
        'https://autoleapstaticassets.s3.amazonaws.com/Build+an+estimate.mp4';
    } else if (type === 'partstech') {
      attachment.url =
        'https://autoleapstaticassets.s3.amazonaws.com/Parts+Ordering+with+AutoLeap.mp4';
    }
    this.dialogService.open(OverlayVideoComponent, {
      data: attachment,
      width: '80%',
      styleClass: 'add-dialog overflow-auto',
      showHeader: false,
    });
  }

  handleSetUpApt(isScreenLocked: boolean = false) {
    this.setUpApt.emit(isScreenLocked);
  }

  handleSetupRo(isScreenLocked: boolean = false) {
    this.setUpRo.emit(isScreenLocked);
  }

  handleSetupInvite(isScreenLocked: boolean = false) {
    this.helperService.openPageInNewTab(`/settings/users/create`);
  }

  partsOrdering() {
    this.helperService.openPageInNewTab(`/estimate/?tab=3`);
    this.httpService
      .markTrialStep(['isPartsTechUsed'])
      .catch((err) => console.error(err));
  }
}
